import { ReactNode, FC } from 'react';
import { Modal } from 'react-bootstrap';
import ApButton from './ApButton';
import { ApButtonStyle1 } from 'models/ButtonStyles';

export type ApModalProps = {
    show: boolean;
    onHide: () => void;
    backdrop?: boolean | "static";
    keyboard?: boolean;
    autoFocus?: boolean;
};

type ApModalDialogProps = {
    props: ApModalProps,
    header: boolean,
    headerText?: string,
    footer: boolean,
    children?: ReactNode;
};

const ApModalDialog: FC<ApModalDialogProps> = ({ props, header, headerText, footer, children }) => {
    return <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        {header ? <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
                {headerText}
            </Modal.Title>
        </Modal.Header> : ""}
        <Modal.Body className="p-4">
            {children}
        </Modal.Body>
        {footer ? <Modal.Footer>
            <ApButton innerText="Close" btnStyleOption={ApButtonStyle1} clickHandler={props.onHide}></ApButton>
        </Modal.Footer> : ""}
    </Modal>;
}

export default ApModalDialog;